<div class="panel" id="gene-symbols-panel">
  <textarea
    #textArea
    id="text-area"
    type="text"
    (keyup)="geneSymbolsInput$.next(textArea.value)"
    [value]="geneSymbolsInput$ | async"
    class="form-control"
    spellcheck="false"></textarea>
  <span id="sensitivity-note" style="color: #acacac; font-style: italic">* Gene symbols are case-sensitive</span>

  <div [hidden]="geneSymbols.geneSymbols" class="alert alert-warning" role="alert" style="margin-top: 10px">
    <span>Please insert at least one gene symbol.</span>
  </div>

  <div *ngIf="invalidGenes" class="alert alert-danger" role="alert" style="margin-top: 10px">
    <span>Invalid genes: {{ invalidGenes }}</span>
  </div>
</div>
